import * as React from 'react'

export type DisplayScale = 'compact' | 'standard' | 'comfortable'

export interface DisplayScaleContextValue {
  scale: DisplayScale
  setScale: (scale: DisplayScale) => void
  resetScale: () => void
}

export const DisplayScaleContext = React.createContext<
  DisplayScaleContextValue | undefined
>(undefined)
